module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAYAAACAa1QyAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAChSURBVCiRldOhDcJgEMXxX6CyAllZwQAIhugICCQjkMAONGEEcCDwkMAGCAZAIBEIRgDRr/670/e/9/LubogDRngI1ATPBJcRsMQeL0wjIMzwxSoK1rjjiioCFmjxQRNVbfDGNg3KrgoXneVxVHWpC2k+CEC/iEKFs4C9PohWRhAFNgnIirxOVm4yl9uf0TqnucRO4GD71zgKvMYJi9xm+AOFBx3NbpM2wwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/next_page.png
// module id = 9UVs
// module chunks = 8